// Fourteen papers, newest first, grouped by year on the publications view.
// `venue` is the publisher and `date` the day and month, omitted where the
// publisher gives none. The home view shows the three ids listed in
// RECENT_PAPER_IDS with a "YEAR · venue" meta instead.

const PAPERS = [
	{
		id: "meta-reasoning",
		year: "2026",
		venue: "Academia AI and Applications",
		title: "Meta-reasoning in autonomous agents: performance gains across benchmarks and models",
		link: "https://www.academia.edu/3071-0286/2/1/10.20935/AcadAI8229",
	},
	// {
	// 	id: "blockchain-fl",
	// 	year: "2024",
	// 	date: "04 Dec",
	// 	venue: "IEEE Access",
	// 	title: "Blockchain enabled federated learning for detection of malicious Internet of Things nodes",
	// 	link: "https://doi.org/10.1109/ACCESS.2024.3511272",
	// },
	{
		id: "small-models",
		year: "2024",
		date: "01 Nov",
		venue: "IEEE CS",
		title: "Small models, big impact: the sustainable future of AI language models",
		link: "https://www.computer.org/publications/tech-news/community-voices/sustainable-future-of-ai-language-models",
	},
	{
		id: "ai-reliability",
		year: "2024",
		date: "08 Oct",
		venue: "INFORMS",
		title: "Enhancing AI reliability: the power of context in large language models",
		link: "https://doi.org/10.1287/LYTX.2024.04.09",
	},
	{
		id: "guardrails-governance",
		year: "2024",
		date: "19 Sep",
		venue: "IEEE CS",
		title: "Guardrails and governance: navigating the complexities of generative AI in enterprise operations",
		link: "https://www.computer.org/publications/tech-news/community-voices/generative-ai-in-enterprise-operations/",
	},
	// {
	// 	id: "copy-move",
	// 	year: "2024",
	// 	date: "30 Aug",
	// 	venue: "IEEE Access",
	// 	title: "Copy-move forgery detection using graph convolutional network feature extraction",
	// 	link: "https://doi.org/10.1109/ACCESS.2024.3452609",
	// },
	{
		id: "synthetic-clinical",
		year: "2024",
		date: "28 May",
		venue: "arXiv",
		title: "Enhancing clinical documentation with synthetic data: leveraging generative models for improved accuracy",
		link: "https://arxiv.org/abs/2406.06569",
	},
	{
		id: "finembeddiff",
		year: "2024",
		date: "21 May",
		venue: "arXiv",
		title: "FinEmbedDiff: a cost-effective approach of classifying financial documents with vector sampling using multi-modal embedding models",
		link: "https://arxiv.org/abs/2406.01618",
	},
	{
		id: "hybrid-nlp",
		year: "2024",
		date: "18 May",
		venue: "arXiv",
		title: "Synergizing unsupervised and supervised learning: a hybrid approach for accurate natural language task modeling",
		link: "https://arxiv.org/abs/2406.01096",
	},
	{
		id: "clinical-documentation",
		year: "2024",
		date: "05 May",
		venue: "arXiv",
		title: "Intelligent clinical documentation: harnessing generative AI for patient-centric clinical note generation",
		link: "https://arxiv.org/abs/2405.18346",
		badge: "PaperDigest most influential arXiv AI paper, 2024",
		badgeShort: "PaperDigest most influential, 2024",
	},
	{
		id: "rotated-documents",
		year: "2024",
		date: "29 Mar",
		venue: "arXiv",
		title: "Robustness of structured data extraction from in-plane rotated documents using multi-modal large language models",
		link: "https://arxiv.org/abs/2406.10295",
	},
	{
		id: "context-grounding",
		year: "2023",
		date: "13 Nov",
		venue: "arXiv",
		title: "Improving large language model fidelity through context-aware grounding: a systematic approach to reliability and veracity",
		link: "https://arxiv.org/abs/2408.04023",
	},
	{
		id: "llm-guardrails",
		year: "2023",
		date: "01 Nov",
		venue: "JST",
		title: "Guardrails for trust, safety, and ethical development and deployment of large language models",
		link: "https://doi.org/10.55662/JST.2023.4605",
	},
	{
		id: "media-insights",
		year: "2019",
		date: "24 Aug",
		venue: "ResearchGate",
		title: "Media Insights Engine for advanced media analysis: a case study of a computer vision innovation for pet health diagnosis",
		link: "https://www.researchgate.net/publication/379035181_Media_Insights_Engine_for_Advanced_Media_Analysis_A_Case_Study_of_a_Computer_Vision_Innovation_for_Pet_Health_Diagnosis",
	},
];

// The three surfaced under "04 · Recent papers" on home.
const RECENT_PAPER_IDS = [
	"meta-reasoning",
	"blockchain-fl",
	"clinical-documentation",
];

const RECENT_PAPERS = RECENT_PAPER_IDS.map((id) =>
	PAPERS.find((paper) => paper.id === id)
).filter(Boolean);

// Years in the order they appear on the publications view.
const PAPER_YEARS = PAPERS.reduce(
	(years, paper) =>
		years.includes(paper.year) ? years : years.concat(paper.year),
	[]
);

const PAPERS_BY_YEAR = PAPER_YEARS.map((year) => ({
	year,
	papers: PAPERS.filter((paper) => paper.year === year),
}));

const PUBLICATIONS_INTRO =
	"Peer-reviewed research, preprints, and invited technical writing, mostly on document intelligence, model reliability, and the guardrails around generative systems.";

export {
	PAPERS,
	RECENT_PAPERS,
	PAPERS_BY_YEAR,
	PUBLICATIONS_INTRO,
};
